import { loadEnvironmentConfig } from './shared/common-utilities/services/EnvironmentService';
 
loadEnvironmentConfig().then(() => {
  import('./bootstrap'); 
});
 
 